import { fromMarkdown, toMarkdown } from 'mdast-util-gfm-strikethrough';
import gfmStrikethroughExtension from 'micromark-extension-gfm-strikethrough';

function strikethroughToMarkdown() {
    return {
        extensions: [toMarkdown],
    };
}
function strikethroughRemarkPlugin() {
    var data = this.data();
    var micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
    var fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
    var toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
    micromarkExtensions.push(gfmStrikethroughExtension({ singleTilde: false }));
    fromMarkdownExtensions.push(fromMarkdown);
    toMarkdownExtensions.push(strikethroughToMarkdown());
}

export { strikethroughRemarkPlugin };
